import { useCallback } from "react";

import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import StyledDialog from "../../../../common/components/dialog/StyledDialog";
import { useDialog } from "../../../../common/components/dialog/useDialog";
import FeedbackDetailsForm from "./FeedbackDetailsForm";

export interface IFeedbackDetailsButtonProps {
  loading?: boolean;
  mitigatedRisk?: string[];
  onSubmitClick: (mitigatedRisk: string[]) => Promise<void>;
}

const AddFeedbackDetailsButton = ({
  loading = false,
  mitigatedRisk = [],
  onSubmitClick,
}: IFeedbackDetailsButtonProps) => {
  const { open, handleDialogOpen, handleDialogClose } = useDialog();

  const memoizedSubmitCallback = useCallback(
    async (mitigatedRisk: string[]) => {
      await onSubmitClick(mitigatedRisk);

      handleDialogClose();
    },
    [mitigatedRisk]
  );

  return (
    <>
      <Button
        variant="text"
        size="small"
        startIcon={<AddOutlinedIcon />}
        onClick={handleDialogOpen}
      >
        <Typography variant="buttonMedium">Add details</Typography>
      </Button>

      <StyledDialog
        open={open}
        onClose={handleDialogClose}
        showSubmitButton={false}
        title="Mitigated Risk, Avoided Liabilities"
        subTitle="Select all applicable risks mitigated or liabilities avoided"
      >
        <FeedbackDetailsForm
          mitigatedRisk={mitigatedRisk}
          submitLoading={loading}
          onSubmitClick={memoizedSubmitCallback}
          onCancel={handleDialogClose}
        />
      </StyledDialog>
    </>
  );
};

export default AddFeedbackDetailsButton;
